import { Component } from "react";
import "./Dialog.css";
import PropTypes from "prop-types";
import Modal from "simple-react-modal";

/**
 * Talaera wrapper for [simple-react-modal](https://www.npmjs.com/package/simple-react-modal).
 * Specifies custom structure and CSS class names.
 */
export default class Dialog extends Component {
  render() {
    let className = "dialog-wrapper";
    if (this.props.className) {
      className += " " + this.props.className;
    }

    return (
      <Modal
        className={className}
        show={this.props.showDialog}
        closeOnOuterClick={
          this.props.closeOnOuterClick !== undefined ? this.props.closeOnOuterClick : true
        }
        onClose={this.props.onClose}
      >
        <div className="dialog" data-cy={this.props.dataCy}>
          {this.props.children}
        </div>
      </Modal>
    );
  }
}

Dialog.propTypes = {
  /** Additional CSS class names to apply to Modal. */
  className: PropTypes.string,
  /** Boolean value that defines whether to show dialog or not. */
  showDialog: PropTypes.bool.isRequired,
  /** Boolean value that defines whether to close the dialog if someone clicks outside of the modal window. */
  closeOnOuterClick: PropTypes.bool,
  /** Function/callback that invokes when dialog is being closed. */
  onClose: PropTypes.func.isRequired,
  /** "Identificator" for Modal's content to use in cypress tests. */
  dataCy: PropTypes.string,
};
